export var IFilterOption;
(function (IFilterOption) {
    /**
     * A list of decorations that the frontend should use for select FilterOptions.
     * This enables decorations for things like season-based promotions or for the inception use-case of
     * highlighting preorder seasons as part of Evergreen Preorder Visibility.
     */
    let Customizations;
    (function (Customizations) {
        Customizations["CUSTOMIZATIONS_UNKNOWN"] = "CUSTOMIZATIONS_UNKNOWN";
        /**
         * For evergreen preorder seasons - decorate in side nav with "New!"
         */
        Customizations["EVERGREEN_NEW"] = "EVERGREEN_NEW";
        /**
         * For faire fashion week preorder options - decorate in side nav with twinkle icon
         */
        Customizations["FAIRE_FASHION_WEEK"] = "FAIRE_FASHION_WEEK";
    })(Customizations = IFilterOption.Customizations || (IFilterOption.Customizations = {}));
    let SelectionState;
    (function (SelectionState) {
        SelectionState["SELECTION_STATE_UNKNOWN"] = "SELECTION_STATE_UNKNOWN";
        /**
         * The filter option is selected. If it has sub-options, they're all selected too.
         */
        SelectionState["FULLY_SELECTED"] = "FULLY_SELECTED";
        /**
         * The filter option is unselected but has selected sub-options.
         */
        SelectionState["PARTIALLY_SELECTED"] = "PARTIALLY_SELECTED";
        /**
         * The filter option isn't selected. If it has sub-options, they're all unselected too.
         */
        SelectionState["UNSELECTED"] = "UNSELECTED";
    })(SelectionState = IFilterOption.SelectionState || (IFilterOption.SelectionState = {}));
    /**
     * Return an instance of IFilterOption with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    IFilterOption.build = (partial) => (Object.assign({ sub_options: [], customizations: [] }, (partial !== null && partial !== void 0 ? partial : {})));
})(IFilterOption || (IFilterOption = {}));
